import type { ConstValues } from '@openx/types/helpers';
import type { Option } from '@openx/types/options';
import type { EnrichedSeat } from '@openx/types/seat';

export type CuratedDealBuyerDiscountsFormData = {
  apply_to: CuratedDealBuyerDiscountApplyTo | null;
  banner_and_video_discount: string | number;
  ctv_discount: string | number;
  demand_partner: Option | null;
  /** This field is used only for validation and its values is not important */
  min_one_discount_error: '';
  name: string;
  seat_ids: Record<string, CuratedDealBuyerDiscountSeat>;
};

export type CuratedDealBuyerDiscountSeat = {
  used_by_curateddealbuyerdiscount: boolean;
} & Pick<EnrichedSeat, 'buyer_path' | 'demand_partner_id' | 'id' | 'name' | 'seat_id'>;

export const curatedDealBuyerDiscountApplyTo = {
  DemandPartner: 'demand_partner',
  Seats: 'seats',
} as const;
export type CuratedDealBuyerDiscountApplyTo = ConstValues<typeof curatedDealBuyerDiscountApplyTo>;
